export default {"src":"/_next/static/media/aw.b7e6e720.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};